export default {"src":"/_next/static/media/timeIcon.7f16d56f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};